export var Currency;
(function (Currency) {
    Currency["USDC"] = "USDC";
    Currency["DAI"] = "DAI";
    Currency["WETH"] = "WETH";
    Currency["WMATIC"] = "WMATIC";
})(Currency || (Currency = {}));
export var DecryptionConditionsTypes;
(function (DecryptionConditionsTypes) {
    DecryptionConditionsTypes["AccessControlCondition"] = "AccessControlCondition";
    DecryptionConditionsTypes["UnifiedAccessControlCondition"] = "UnifiedAccessControlCondition";
})(DecryptionConditionsTypes || (DecryptionConditionsTypes = {}));
